import React from "react";

function Button({ children }) {
  return (
    <button className="py-3 px-5 lg:py-4 lg:px-7 text-sm lg:text-md bg-prime text-white hover:bg-primeDark hover:text-white active:bg-prime ease-in duration-100">
      {children}
    </button>
  );
}

export default Button;
